<template>
  <div class="container">
    <div class="filter">
      <div class="cat">
        <el-row class="row">
          <el-col :md="2" class="col">行业分类</el-col>
          <el-col :md="3" class="col">
            <el-select
              v-model="cat"
              placeholder="请选择"
              size="mini"
              @change="changeCat"
            >
              <el-option
                v-for="item in industryArr"
                :key="item.name"
                :label="item.name"
                :value="item.name"
              >
              </el-option>
            </el-select>
          </el-col>
          <el-col :md="2" :offset="1" class="col">行业细分</el-col>
          <el-col :md="3" class="col">
            <el-select
              v-model="subCat"
              placeholder="请选择"
              size="mini"
              @change="changeSubCat"
            >
              <el-option
                v-for="item in subCatArr"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="box industry">
      <h3>行业概况</h3>
      <div class="content">
        <div class="item">
          <p class="value">{{ industryData.materialNum | separateNum }}</p>
          <p class="label">素材数</p>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="item">
          <p class="value">{{ industryData.showNum | separateNum }}</p>
          <p class="label">总展示数</p>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="item">
          <p class="value">
            {{
              (
                (industryData.clickRate ? industryData.clickRate : 0) * 100
              ).toFixed(2)
            }}%
          </p>
          <p class="label">平均点击率</p>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="item">
          <p class="value">{{ industryData.deviceNum | separateNum }}</p>
          <p class="label">展示设备数</p>
        </div>
        <el-divider direction="vertical"></el-divider>
        <div class="item">
          <p class="value">{{ industryData.clickDeviceNum | separateNum }}</p>
          <p class="label">点击设备数</p>
        </div>
      </div>
    </div>
    <div class="box show-time" v-if="showTimeShow">
      <h3>时间投放趋势</h3>
      <div class="content">
        <div class="chart">
          <div id="chartShowTime" class="chart"></div>
        </div>
      </div>
    </div>
    <div class="box city-level" v-if="cityLevelShow">
      <h3>城市等级分布</h3>
      <div class="content">
        <div class="chart">
          <div id="chartCityLevel" class="chart"></div>
        </div>
      </div>
    </div>
    <div class="box zone" v-if="zoneShow">
      <h3>投放地域分布</h3>
      <div class="content">
        <div class="chart">
          <div id="chartZone" class="chart"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
let chinaJson = require("../assets/china.json");
import _ from "underscore";
export default {
  name: "Industry",
  mounted() {
    let session = this.$route.query["session"];
    if (!!session) {
      sessionStorage.setItem("session", session);
      sessionStorage.setItem("isLogin", "1");
    }
    this.querySerchConfig();
    this.chartShowTime = this.$echarts.init(
      document.getElementById("chartShowTime")
    );
    this.chartCityLevel = this.$echarts.init(
      document.getElementById("chartCityLevel")
    );
    this.chartZone = this.$echarts.init(document.getElementById("chartZone"));
    window.addEventListener("resize", this.resize);

    this.queryIndustry();
  },
  data() {
    return {
      cat: "教育",
      subCat: "学前教育",
      options: [],
      industryData: {},
      industryArr: [],
      subCatArr: [],
      startDate: "",
      endDate: "",
      showTimeShow: true,
      cityLevelShow: true,
      zoneShow: true,
    };
  },
  methods: {
    queryIndustry() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
      });
      this.$http
        .get("/fireeye/industry/details?name=" + this.subCat)
        .then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code == 1) {
            this.industryData = data.data;
          }
        })
        .finally(() => {
          loading.close();
        });
      this.queryShowTimeData();
      this.queryCityLevelData(this.subCat);
      this.queryZoneData(this.subCat);
    },
    querySerchConfig() {
      this.$http.get("/fireeye/material/search/config").then((res) => {
        console.log(res);
        let data = res.data;
        console.log(data);
        this.industryArr = data.data.industrys;
        if (this.industryArr.length > 0) {
          this.cat = this.industryArr[0].name;
          for (let item of this.industryArr) {
            if (item.name == this.cat) {
              this.subCatArr = item.tags;
              if (this.subCatArr.length > 0) {
                this.subCat = this.subCatArr[0];
              }
            }
          }
        }
      });
    },
    changeCat(cat) {
      for (let item of this.industryArr) {
        if (item.name == cat) {
          this.subCatArr = item.tags;
        }
      }
      if (this.subCatArr.length > 0) {
        this.$set(this, "subCat", this.subCatArr[0]);
      }
      this.queryIndustry();
    },
    changeSubCat() {
      this.queryIndustry();
    },
    resize() {
      this.chartShowTime.resize();
      this.chartCityLevel.resize();
      this.chartZone.resize();
    },
    queryShowTimeData() {
      this.$http
        .get(
          "/fireeye/industry/trend?name=" +
            this.subCat +
            "&st=" +
            this.startDate +
            "&ed=" +
            this.endDate
        )
        .then((res) => {
          let data = res.data;
          if (data.code == 1 && !!data.data && data.data.length > 0) {
            data = data.data;
            this.showTimeData = data;
            this.drawShowtimeChart();
          } else {
            this.showTimeShow = false;
          }
        });
    },
    drawShowtimeChart() {
      let xAxis = [];
      let display = [];
      let click = [];
      for (let item of this.showTimeData) {
        xAxis.push(item.day);
        display.push(item.show);
        click.push(item.click);
      }
      let series = [
        {
          name: "展示",
          type: "line",
          smooth: true,
          data: display,
        },
        {
          name: "点击",
          type: "line",
          smooth: true,
          data: click,
        },
      ];

      console.log(xAxis, display, click);
      // 指定图表的配置项和数据
      var option = {
        tooltip: { show: true, trigger: "axis" },
        legend: {
          data: ["展示", "点击"],
        },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: series,
      };

      this.chartShowTime.setOption(option);
    },
    queryCityLevelData() {
      this.$http
        .get("/fireeye/industry/distribution/city?name=" + this.subCat)
        .then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code === 1 && !!data.data && !_.isEmpty(data.data)) {
            this.cityLevelData = data.data;
            this.drawCityLevelChart();
          } else {
            this.cityLevelShow = false;
          }
        });
    },
    drawCityLevelChart() {
      let xAxis = [];
      let yAxis = [];
      let all = 0;
      for (let key in this.cityLevelData) {
        all += this.cityLevelData[key];
      }
      for (let key in this.cityLevelData) {
        let value = ((this.cityLevelData[key] / all) * 100).toFixed(2);
        xAxis.push(key);
        yAxis.push(value);
      }
      console.log(xAxis, yAxis);
      // 指定图表的配置项和数据
      var option = {
        tooltip: { show: true, trigger: "axis", formatter: "{b}<br/>{c}%" },
        xAxis: {
          type: "category",
          data: xAxis,
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            data: yAxis,
            type: "bar",
            barWidth: "40",
            itemStyle: {
              color: "#02A7F0",
            },
          },
        ],
      };

      this.chartCityLevel.setOption(option);
    },
    queryZoneData() {
      this.$http
        .get("/fireeye/industry/distribution/province?name=" + this.subCat)
        .then((res) => {
          console.log(res);
          let data = res.data;
          if (data.code === 1 && !!data.data && !_.isEmpty(data.data)) {
            this.zoneData = data.data;
            this.drawZoneChart();
          } else {
            this.zoneShow = false;
          }
        });
    },
    drawZoneChart() {
      let all = 0;
      let max = 0;
      let source = [];
      for (let key in this.zoneData) {
        if (this.zoneData[key] > max) {
          max = this.zoneData[key];
        }
        all += this.zoneData[key];
      }
      for (let key in this.zoneData) {
        let value = ((this.zoneData[key] / all) * 100).toFixed(2);
        source.push([key, value]);
      }

      let option = {
        tooltip: { show: true, trigger: "axis", formatter: "{c}%" },
        xAxis: {
          type: "value",
          min: 0,
          max: 100,
          position: "top",
          interval: 10,
        },
        yAxis: {
          type: "category",
          axisTick: {
            show: false,
          },
        },
        dataset: [
          { dimensions: ["name", "value"], source: source },
          {
            transform: {
              type: "sort",
              config: { dimension: "value", order: "asc" },
              print: true,
            },
          },
        ],
        series: [
          {
            type: "bar",
            datasetIndex: 1,
            encode: { x: "value", y: "name" },
            showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            itemStyle: {
              color: "#02A7F0",
            },
          },
        ],
      };
      this.chartZone.setOption(option);
    },
  },
};
</script>
<style lang="less" scoped>
.filter {
  padding: 25px 15px;
  box-shadow: 0 0 5px #ddd;
  border-radius: 6px;
  font-size: 12px;
  margin-bottom: 40px;
  background-color: #fff;

  .search-box {
  }
  .search-btn {
  }
  .row {
    height: 60px;
    line-height: 60px;
    overflow: hidden;

    .col {
      text-align: left;
    }
  }
}
.box {
  border: 1px solid #ddd;
  border-radius: 3px;
  box-shadow: 3px 3px 5px #ddd;
  margin-bottom: 30px;
  padding: 20px;
  background-color: #fff;

  h3 {
    text-align: left;
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #212121;
    line-height: 28px;
    margin: 4px 0 30px;
  }
  .value {
    color: #00a2ff;
    font-size: 20px;
    font-weight: 700;
  }
}
.chart {
  width: 100%;
  height: 500px;
}
.show-time {
  #chartShowTime {
  }
}
.industry .content {
  display: flex;
  justify-content: space-between;
  gap: 20px;

  div.item {
    flex: 1;
    text-align: center;
    .label {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #757575;
      line-height: 20px;
      margin-top: 10px;
    }
    .value {
      font-size: 24px;
      font-family: DINCond-Bold, DINCond;
      font-weight: bold;
      color: #222222;
      line-height: 28px;
      margin-bottom: 10px;
    }
  }
  .el-divider {
    margin-top: 40px;
    height: 24px;
  }
}
</style>